import { RootState } from 'editor/src/store/index';

const isAddLayerDropdownVisible = (state: RootState, dropDownName: string) =>
  state.app.dropdowns.activeAddLayerDropdown === dropDownName;

export default isAddLayerDropdownVisible;
